<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { getToken, gotoNewWindow } from '@/utils/auth'
import store from '@/store'
import { Loading } from 'element-ui'
import { Message } from '@qs/ui'

export default {
  name: 'App',
  data() {
    return {
      message: null,
    }
  },
  methods: {
    // 倒计时
    countTime(time) {
      setTimeout(() => {
        if (time >= 0) {
          this.countTime(--time)
        }
      }, 1000)
    },
  },
  mounted() {
    // 切换公司或者换账号导致 token变化就刷新到工作台
    const dom = document.getElementsByTagName('body')[0]
    let timer = null
    dom.addEventListener(
      'click',
      (e) => {
        const { token } = store.getters
        if (getToken() !== '' && token !== getToken()) {
          // 阻止事件传播
          const event = e || window.event
          event.cancelBubble
            ? (event.cancelBubble = true)
            : event.stopPropagation()

          // 节流 提示 3秒
          if (!timer) {
            Loading.service()
            timer = setTimeout(() => {
              gotoNewWindow()
            }, 3000)
            this.message = Message({
              duration: 3000,
              message: '请稍候',
            })
            this.countTime(2)
          }
        }
      },
      true,
    )
  },
}
</script>
<style>
.echarts {
  width: 100% !important;
}
.text-blue {
  color: rgb(64, 158, 255) !important;
}
</style>

